import type {LazyMasonryGridProps} from '@Components/lazy-masonry-grid/lazy-masonry-grid';

export const AI_TEXT_TO_IMAGE_EMPTY_VISUAL_ASSET_PATH = 'poster-editor-thumbnails/ai-text-to-image-empty-visual.png';

export interface TextToImageGridProps extends Partial<LazyMasonryGridProps> {
  isLoading?: boolean;
  onRetry?(): void;
  gridClasses?: string;
  gridId: string;
}
